import { useDocumentStore } from "../store/document";

export function maintenanceModeChanged(enabled: boolean, message: string | undefined) {
  const documentStore = useDocumentStore();
  documentStore.maintenanceMessage = message;
  documentStore.maintenanceMode = enabled;
}
